import React, { FC } from 'react';

import Styled from './styles';
import { Typography } from '../typography';
import RoundImg from '../avatar';
import colors from '../../assets/colors';
import MUIButton from "../mui-button";

export type ButtonType = {
	Approved: string;
	'Not member': string;
	'Pending...': string;
	Invited: string;
};

type ButtonOptions = {
	background: keyof typeof colors;
	color: keyof typeof colors;
};

type IButtons<T> = {
	[K in keyof T]: ButtonOptions;
};

const buttons: IButtons<ButtonType> = {
	Approved: {
		background: 'btnGreen',
		color: 'btnTextGreen',
	},
	'Not member': {
		background: 'grey',
		color: 'navText',
	},
	Invited: {
		background: 'btnGreen',
		color: 'sapphirine',
	},
	'Pending...': {
		background: 'btnYellow',
		color: 'btnTextGrey',
	},
};

const InviteItem: FC<any> = ({ item, selectUser }) => {
	const { _id, firstName, lastName, isParticipated, avatar } = item;
	const fullName = `${firstName ? firstName + ' ' : ''}${lastName || ''}`;
	const buttonText = isParticipated ? 'Invited' : 'Not member';
	return (
		<Styled.Row>
			<Styled.LeftPart>
				<RoundImg avatar={avatar} size={43} name={fullName} />
				<Typography type="bold" numberOfLines={1} style={{ marginLeft: 13 }}>
					{fullName}
				</Typography>
			</Styled.LeftPart>
			<Styled.RightPart>
				<Styled.StatusText
					color={buttons[buttonText].color}
					background={buttons[buttonText].background}
					size="normal"
				>
					{buttonText}
				</Styled.StatusText>
				{!isParticipated ? (
					<MUIButton title='Invite' callBack={() => selectUser(_id)} size='small' variant='outlined' backgroundColor='none' color='black' />
				) : <MUIButton title='Invite' callBack={() => selectUser(_id)} size='small' variant='outlined' backgroundColor='none' color='black' disabled />}
			</Styled.RightPart>
		</Styled.Row>
	);
};

export default InviteItem;
